module.exports = __webpack_public_path__ + "static/logo_footer-51b4b01e80700c3fab63289d03c8b90d.svg";